export default {
    facebook: '//www.facebook.com/sharer/sharer.php?u={{href}}',
    twitter: '//twitter.com/intent/tweet?text={{text}}&url={{href}}',
    vkontakte: '//vk.com/share.php?url={{href}}',
};
